import { render, staticRenderFns } from "./WaitListQueue.vue?vue&type=template&id=4f7367d0"
import script from "./WaitListQueue.vue?vue&type=script&lang=ts"
export * from "./WaitListQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports